import React from 'react'
import { I18n } from 'react-redux-i18n'

class CompositionViewOption extends React.Component {

  render () {
    return (
      <div
        className="composition-sort-wrap qw-flex qw-items-center qw-justify-center qw-cursor-pointer qw-display-none">
        <span>
          <p
            className="sort-label qw-right-align qw-font-size-small qw-font-size-body qw-line-height-small qw-color-text-secondary-body">{I18n.t('compositions.sortBy')}</p>
            <p
              className="selected-sort qw-font-size-small qw-color-text-body qw-line-height-small"> {I18n.t('compositions.sortFields.urgency')}</p>
        </span>
      </div>
    )
  }
}

export default CompositionViewOption



// WEBPACK FOOTER //
// ./src/app/components/compositions/CompositionSortOption.js